import { Layout, Menu } from "antd";
import { UserMenu } from "components/custom";
import { getMenuItems } from "layout/menuItems";
import { useMemo } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Button from "../button/button";
import styles from "./index.module.less";
import Icon from "../icon/icon";
import Dropdown from "../dropdown/dropdown";
import theme from "utils/themeVars";
import NotificationBell from "components/custom/notificationBell";

const PageLayout = ({
  children,
  showSubMenu = true,
  backIcon = false,
  label,
  dropDownItems = [],
  showDropDown = false,
  renderCustomActions = () => {},
}) => {
  const { Content } = Layout;
  const menuItems = useMemo(() => getMenuItems(), []);
  const navigate = useNavigate();
  const location = useLocation();

  const { itemList, activeItem } = useMemo(() => {
    const currentItem = menuItems.find(
      (item) =>
        location.pathname === item.key ||
        location.pathname.startsWith(`${item.key}/`)
    );
    const subPaths = currentItem?.subPaths || [];
    const selected = subPaths.find((item) => item.key === location.pathname);
    return {
      itemList: subPaths,
      activeItem: selected ? [selected.key] : [],
    };
  }, [location.pathname, menuItems]);

  return (
    <Layout>
      <Content className={styles.newBody}>
        <div className={styles.newHeader}>
          {itemList?.length && showSubMenu ? (
            <Menu
              onClick={(item) => {
                navigate(item.key);
              }}
              selectedKeys={activeItem}
              mode="horizontal"
              items={itemList}
              style={{ width: "100%" }}
              className={styles.navMenu}
            />
          ) : (
            <div className={styles.pageTitle}>
              {backIcon && (
                <Icon
                  className="pointer"
                  onClick={() => navigate(-1)}
                  icon="IoMdArrowBack"
                  size="22px"
                  color="#1D1B20"
                />
              )}
              {label && label}
            </div>
          )}

          <div className={styles.headerActionItems}>
            {renderCustomActions()}
            <NotificationBell />
            <UserMenu />
            {showDropDown && (
              <Dropdown
                options={dropDownItems}
                trigger="click"
                arrow={false}
                suffixIcon=""
                style={{ backgroundColor: "transparent" }}
              >
                <Button
                  icon={"SlOptionsVertical"}
                  iconProps={{ size: "16px", color: theme["primary-color"] }}
                  shape="circle"
                  style={{ border: "1px solid #c5c6d0" }}
                />
              </Dropdown>
            )}
          </div>
        </div>
        <div className={styles.newContent}>{children}</div>
      </Content>
    </Layout>
  );
};

export default PageLayout;
